import { CarrierLogo } from '@/components/carrier-logo';
import { Tooltip } from '@/components/tooltip';
import { RouteCarrierApiV2Interface, SegmentModeType } from '@/types/api-types';
import { getCarrierName } from '@/utils/carrier';
import { getPreferredIdentifier } from '@/utils/helpers';
import { tv } from '@/utils/styles';

interface Props {
  carriers: RouteCarrierApiV2Interface[];
  mode: SegmentModeType;
  size?: 'sm' | 'md';
  limit?: number;
}

const CarrierLogos = ({ carriers, mode, size = 'md', limit = 5 }: Props) => {
  const limitedCarriers = carriers.slice(0, limit);
  const carrierCount = carriers.length;
  const visibleCarriersCount = carrierCount > limit ? limit : carrierCount;
  const remainingCarrierCount = carrierCount - limitedCarriers.length;

  const { circle } = styles({ size });

  return (
    <span className="flex">
      {limitedCarriers.map((carrier, index) => {
        const carrierCode = carrier ? getPreferredIdentifier(carrier.identifiers)?.value : '';
        const carrierName = getCarrierName(carrier);
        const hoverIndex = visibleCarriersCount - (index + 1);
        // eslint-disable-next-line react/no-array-index-key
        return (
          <Tooltip key={`${carrierCode}_${index}`} content={carrierName}>
            <div style={{ zIndex: hoverIndex }} className={circle()}>
              {carrierCode ? (
                <CarrierLogo carrierCode={carrierCode} mode={mode} size={size === 'sm' ? '14px' : 5} />
              ) : null}
            </div>
          </Tooltip>
        );
      })}
      <Tooltip content={`+ ${remainingCarrierCount} more`}>
        {remainingCarrierCount > 0 && <div className={circle()}>+{remainingCarrierCount}</div>}
      </Tooltip>
    </span>
  );
};

const styles = tv({
  slots: {
    circle:
      'grid place-items-center rounded-full bg-white text-[10px] text-grey-500 shadow-[0_0_1px_rgba(0,0,0,0.5)] first:!ml-0 hover:!z-5',
  },
  variants: {
    size: {
      md: {
        circle: '-ml-4 size-8',
      },
      sm: {
        circle: '-ml-[0.4rem] size-5',
      },
    },
  },
});

export { CarrierLogos };
